import React from 'react'
import { compose } from 'redux'
// import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Dialog, Fade } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import * as directoryActions from '../../../../actions/components/directory'
import PoweredBy from '../PoweredBy'

const Transition = React.forwardRef(function Transition (props, ref) {
  const timeout = { enter: 0, exit: 500 }
  return <Fade {...props} ref={ref} timeout={timeout} />
})

class Intro extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  closeIntroCoverImageDialog = () => this.props.updateDisplayIntro(false)

  render () {
    const { classes, merchant, directory } = this.props
    if (!merchant) return null

    const { intro } = directory.display
    const backgroundImage = merchant && merchant.setting.directoryBackgroundImage

    return (
      <Dialog
        open={intro}
        onClose={this.closeIntroCoverImageDialog}
        TransitionComponent={Transition}
        fullScreen
      >
        <div
          className={classes.coverImage}
          style={{ backgroundImage: `url(${backgroundImage})` }}
          onClick={this.closeIntroCoverImageDialog}
        >
          <PoweredBy style={{ marginBottom: 24 }} />
        </div>
      </Dialog>
    )
  }
}

const styles = {
  coverImage: {
    height: '100vh',
    width: '100vw',
    backgroundColor: '#0000004d',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    directory: state.directory,
  }
}

const mapDispatchToProps = {
  updateDisplayIntro: directoryActions.updateDisplayIntro,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  injectIntl,
)(Intro)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Dialog/Intro.jsx